import React from "react";
import { Link } from "react-router-dom";
import {
  CurrencyDollarIcon,
  UserIcon,
  CubeIcon,
  ShoppingCartIcon,
  PhotographIcon,
} from "@heroicons/react/solid";

const cardClassName =
  "bg-white shadow-lg rounded-lg p-8 flex flex-col items-center text-center transform transition duration-300 hover:scale-105 min-h-[190px] justify-center";

const BusinessDashboard = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center pt-16 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 w-full max-w-6xl">
        {/* Wallet */}
        <Link
          to="/businessOrders"
          className="block h-full sm:col-span-2 lg:col-span-2"
        >
          <div className={cardClassName}>
            <ShoppingCartIcon className="h-16 w-16 text-red-500 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Orders</h2>
          </div>
        </Link>
        <Link to="/businessWallet" className="block h-full">
          <div className={cardClassName}>
            <CurrencyDollarIcon className="h-16 w-16 text-green-500 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Wallet</h2>
          </div>
        </Link>

        {/* Users */}
        <Link to="/businessUsers" className="block h-full">
          <div className={cardClassName}>
            <UserIcon className="h-16 w-16 text-blue-500 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Users</h2>
          </div>
        </Link>

        {/* Banners */}
        <Link to="/banner" className="block h-full">
          <div className={cardClassName}>
            <PhotographIcon className="h-16 w-16 text-pink-500 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Banners</h2>
          </div>
        </Link>

        {/* Products */}
        <Link to="/businessproducts" className="block h-full">
          <div className={cardClassName}>
            <CubeIcon className="h-16 w-16 text-purple-500 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Products</h2>
          </div>
        </Link>

       
      </div>
    </div>
  );
};

export default BusinessDashboard;
